import React, { Component } from "react";
import { ErrorBox } from "../components/ErrorBox";
import { NextButton } from "../components/NextButton";
import { StandardButton } from "../components/StandardButton";

interface IProps {
  gtmEvent(): void;
  name: string;
  firstname2?: string;
  lastname2?: string;
  email2?: string;
  applicationType: string;
  updateLead(props: any): void;
  nextStep(s: string): void;
  contactHasProfile?: boolean;
}

interface IState {
  hasError: boolean;
  errors?: string[];
  firstname2?: string;
  lastname2?: string;
  email2?: string;
}

export class FastTrack extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { hasError: false };
  }

  componentDidMount(): void {
    this.props.gtmEvent();
  }

  nextStep(response: string): boolean {
    if (response === "yes") {
      this.props.updateLead({ navigateToInvite: true });
    }
    this.props.nextStep(response);
    return true;
  }

  hasErrors(): boolean {
    if (
      this.props.applicationType === "joint" &&
      (!this.state.email2 || !this.state.firstname2 || !this.state.lastname2)
    ) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <>
        <header className="App-header bgchartreuse pt-2 pb-2">
          <div className="wrapper">
            <div className="row">
              <div className="column2 flex-start justify-s">
                <h1 className="l justify-s">
                  Good news {this.props.name ?? ""},
                </h1>
                <p className="m pt-1">
                  Based on your details and the Loan to Value (LTV), you’re
                  ready to be fast tracked through to mortgage approval.
                </p>
                {/* <ul className='pt-0-5 pb-0-5'>
                                <li>Complete your application for approval</li>
                                <li>Manage all your documents in one place</li>
                                <li>Chat with your dedicated advisor</li>
                                <li>Check progress and updates right through to completion of your mortgage</li>
                            </ul> */}
                <h2 className="m pt-2">
                  <strong>
                    Check your email for a link to our secure mortgage portal to
                    continue your application
                  </strong>
                </h2>
                <div className="row mt-0 mb-0 justify-s desktop">
                  <div className="column1 justify-s">
                    {/* <div className='button-group mt-1'>
                                        <NextButton 
                                            customLabel='Not now'
                                            type='transparent'
                                            customClass='btn-noleftmargin'
                                            url="/"
                                        />
                                        <NextButton 
                                            customLabel="Let's go!"
                                            onClick={() => {return this.nextStep('yes');}}
                                        />
                                    </div> */}
                  </div>
                </div>
                {/* <NextButton 
                                    customLabel="Let's go!"
                                    customClass='btn-noleftmargin mobile mt-2'
                                    onClick={() => {return this.nextStep('yes');}}
                                />
                                <NextButton 
                                    customLabel='Not now'
                                    type='transparent'
                                    customClass='btn-noleftmargin mt-1 mobile '
                                    url="/"
                                /> */}
                <p className="m pt-2">
                  You've already provided a lot of the details required for
                  mortgage approval. Turn this into your application. Get
                  approval, manage your documents, and chat to your free
                  personal mortgage advisor all the way to draw-down. All at no
                  cost to you.
                </p>
              </div>
              <div className="column2 flex-start">
                <div className="dmx-mobile" />
              </div>
            </div>
            {this.state.hasError && <ErrorBox errors={this.state.errors!} />}
            <div className="box chartreuse desktop mt-2">
              <div className="row">
                <p>
                  If you have any questions please login to the portal where you
                  can use our secure messaging app to send your dedicated
                  advisor a message
                </p>
              </div>
            </div>
          </div>
        </header>
      </>
    );
  }
}
